import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { compose } from 'recompose';
import ReactSpeedometer from "react-d3-speedometer";
import { Legend, Tooltip, PieChart, Pie, Cell } from 'recharts';

import { withStyles } from '@material-ui/core/styles';

import { makeGetCosts } from '../../store/selectors';

const COLORS = [ '#FF8042', '#81C784', '#FFB74D', '#7986CB' ];


const styles = theme => ({
  root: {
    display: 'flex',
    flexDirection: 'row',
    flexWrap: 'wrap',
    justifyContent: 'space-evenly',
    alignItems: 'center',
    flexGrow: 1
  },
});

const InvoiceMetrics = ({classes, invoice, costs}) => {
  return(
    <div className={classes.root}>
      <PieChart width={200} height={200} onMouseEnter={this.onPieEnter}>
        <Pie
          data={costs.pieCartData}
          dataKey="value"
          cx="50%"
          cy="50%"
          labelLine={false}
          outerRadius="100%"
          fill="#8884d8"
        >
          {
            costs.pieCartData.map((entry, index) => <Cell key={index} fill={COLORS[index % COLORS.length]}/>)
          }
        </Pie>
        <Tooltip/>

        <Legend content={renderLegend} />
      </PieChart>
      <div style={{paddingTop: '70px'}}>
        <ReactSpeedometer

          width={220}
          height={200}
          maxValue={50}
          value={costs.grossMargin}
          startColor="#F44336"
          endColor="#66BB6A"
          currentValueText="Gross Margin"
        />
      </div>
    </div>
  );
};

const renderLegend = (props) => {
  const { payload } = props;
  return (
    <div style={{ marginTop: '5px',
                  display: 'flex',
                  flexDirection: 'row',
                  flexWrap: 'wrap',
                  justifyContent: 'space-between'
                }}>
      {
        payload.map((entry, index) => {
          return(
            <div key={`item-${index}`} style={{ display: 'flex',
                                                paddingLeft: '10px',
                                                paddingRight: '10px'
                                              }}>
              <div style={{ width: '15px',
                            height: '10px',
                            margin: '3px',
                            backgroundColor: entry.color
                          }}>
              </div>
              <div style={{paddingLeft: entry.value=== "Time" ? '2px' : '0px'}}>
                {entry.value}
              </div>
            </div>
          );
        })
      }
    </div>
  );
}

InvoiceMetrics.propTypes = {
  invoice: PropTypes.object.isRequired,
  project: PropTypes.object.isRequired,
};

//Creates own private getCosts selector so that memoization is preserved
const makeMapStateToProps = () => {
  const getCosts = makeGetCosts();
  const mapStateToProps = (state, props) => {
    return {
      costs: getCosts(state, props)
    }
  };

  return mapStateToProps;
}

export default compose(
  withStyles(styles),
  connect(makeMapStateToProps)
)(InvoiceMetrics);



// WEBPACK FOOTER //
// ./src/components/admin/InvoiceMetrics.jsx